var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.996,
    height: 46,
    viewBox: "0 0 39.996 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "doc_icon",
    "data-name": "doc icon",
    transform: "translate(-75.299 -9.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6941",
    "data-name": "Group 6941",
    transform: "translate(75.299 9.993)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M88.665-500.938a14.74,14.74,0,0,0-4.912,2.947,57.367,57.367,0,0,0-5.413,5.4c-1.7,2.093-2.764,3.869-2.967,5-.067.365-.087,5.05-.067,14.017.019,12.664.039,13.518.2,14.056a6.481,6.481,0,0,0,3.236,3.869c1.445.682.636.643,13.532.643,11.009,0,11.692-.009,12.28-.173a6.452,6.452,0,0,0,4.373-4.34,12.181,12.181,0,0,0,.221-1.853l.058-1.267h-3.092l-.039,1.219a3.291,3.291,0,0,1-.26,1.661,3.452,3.452,0,0,1-1.406,1.421l-.482.259-11.6.029-11.6.019-.539-.24a3.275,3.275,0,0,1-1.531-1.44l-.26-.48-.029-13.5L78.36-487.2l2.813-.048c3.14-.048,3.448-.1,4.652-.72A7.141,7.141,0,0,0,88.4-490.53c.626-1.2.674-1.507.722-4.637l.048-2.8,7.387.019,7.378.029.482.259a3.229,3.229,0,0,1,1.435,1.517l.25.528v16.081h3.092l-.039-8.189c-.029-9.092.009-8.506-.7-9.956a6.9,6.9,0,0,0-2.591-2.612c-1.4-.72-.963-.691-9.294-.711C92.421-501.015,88.906-500.986,88.665-500.938Z",
    transform: "translate(-75.299 501.007)",
    fill: "#135baf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6940",
    "data-name": "Group 6940",
    transform: "translate(9.272 22.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M553.614,81.98c-1.486,0-2.044,1.264-2.044,2.581,0,1.253.558,2.518,2.044,2.518s2.044-1.264,2.044-2.518C555.658,83.244,555.1,81.98,553.614,81.98Z",
    transform: "translate(-538.416 -77.63)",
    fill: "#135baf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M393.9,85.79h-1.18v4.741h1.475c.959,0,1.876-.59,1.876-2.255C396.071,86.759,395.544,85.79,393.9,85.79Z",
    transform: "translate(-387.045 -81.26)",
    fill: "#135baf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M302.029-9.475c-.992-.992.347-.906-14.264-.925-10.951-.019-12.839,0-13.282.125a2.766,2.766,0,0,0-1.541.963c-.722.828-.732.867-.732,5.817,0,5.134-.01,5.056.905,5.981.992.982-.308.906,14.457.906s13.465.077,14.457-.906c.915-.925.905-.848.905-5.981S302.944-8.551,302.029-9.475ZM279.476.254h-3.245V-7.268h3.245c1.949,0,3.413,1.222,3.413,3.719C282.889-1.368,281.773.254,279.476.254Zm7.933.179a3.629,3.629,0,0,1-3.7-3.909,3.648,3.648,0,0,1,3.7-3.972,3.648,3.648,0,0,1,3.7,3.972A3.629,3.629,0,0,1,287.409.434Zm8.2,0a3.629,3.629,0,0,1-3.7-3.909,3.648,3.648,0,0,1,3.7-3.972,3.052,3.052,0,0,1,3.245,2.708h-1.6a1.625,1.625,0,0,0-1.643-1.317c-1.486,0-2.044,1.264-2.044,2.581,0,1.253.558,2.518,2.044,2.518a1.7,1.7,0,0,0,1.707-1.686h1.6A3.177,3.177,0,0,1,295.605.434Z",
    transform: "translate(-272.21 10.407)",
    fill: "#135baf"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.b070700181fba03262c33c5592c84914.svg";
export { ForwardRef as ReactComponent };